import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { QuoteModel } from '@amfam/policy/models';

@Component({
  selector: 'ds-quote-sidebar',
  templateUrl: './quote-sidebar.component.html',
  styleUrls: ['./quote-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class QuoteSidebarComponent {
  @Input() noOfVehicles: number;
  @Input() icons: number[];
  @Input() quoteData: QuoteModel;
  @Input() vehicleName: string;
  @Input() needRecalculation: boolean;
  @Input() showResetCoverageButton: boolean;
  @Output() recalculateQuote = new EventEmitter();
  @Output() resetQuote = new EventEmitter();
}
